/**
 * 全站配置
 */
export default {
  // 路由前缀
  routePrefix: 'markets',
  // 请求超时时间
  timeout: 10000,
};
